import {ExportModel} from "./ExportModel";
import {Location} from "../../entities/Location";
import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {LocationService} from "../../services/LocationService";

export class LocationExportModel extends ExportModel<Location>{
    static $inject = ['$q','LocationService','CustomFieldNameService','NotificationService'];
    constructor($q:ng.IQService, assetService:LocationService, public cfnService:CustomFieldNameService, public notifyService:NotificationService){
        super($q, cfnService, assetService, notifyService);
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['name', 'Name', 150],
                ['rfidTag', 'Rfid Tag', 215],
                ['site', 'Site', 125],
                ['building', 'Building', 135],
                ['floor', 'Floor', 150],
                ['room', 'Room', 150],
                ['description', 'Description', 150],
            ]
        return this.$q.when();
    }
    getExportType(){
        return "Location";
    }
}
